import ActionType from './action-types'

const clear = () => dispatch => dispatch({type: ActionType.CLEAR_ERR})

export default {
  clear
}
